import { Text, View } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";
import { FrequencyGroups } from "../../../services/api/types/medications/enums/FrequencyEnum";
import { capitalize } from "ui/utils/textUtils";
import { useMedicationFilterGroups } from "../hooks/useMedicationFilterGroups";

interface Props {
    filters?: string[];
    onChangeFilters?: (filters: string[]) => void;
}
export function MedicationListFrequencyFilter({ filters, onChangeFilters }: Props) {
  const { activeFilterGroups, handlePress } = useMedicationFilterGroups({activeFilters: filters, onChangeFilters});

  return (
    <View className={"flex-row items-center justify-end gap-2"}>
      <Text className={"font-semibold text-xs"}>Frequency</Text>
      {FrequencyGroups.map((option: string) => (
        <Button
          key={option}
          size={"xs"}
          variant={activeFilterGroups.includes(option) ? "solid" : "outline"}
          onPress={() => handlePress(option)}
        >
          <ButtonText>{capitalize(option)}</ButtonText>
        </Button>
      ))}
    </View>
  );
}
